import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';
import { BaseCardEvent } from '../../../Prototype/Level/Card/BaseCard';

export class CardFallIn extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const tween = this.getTween(transform);
        tween
            .to(
                {
                    x: meta.x,
                    y: meta.y,
                    rotation: meta.rotation,
                },
                600
            )
            .easing(Easing.Cubic.Out);

        yield* this.startTween(tween);

        gameObject.emit(BaseCardEvent.INTRO_FALL_IN_COMPLETE);
    }
}
